import { useEffect, useState } from "react";
import api from "@/lib/api";

// Polls the backend Finnhub proxy for real prices. Returns { live: {sym:{p,dp}}, ready }.
export function useLiveRates(intervalMs = 15000) {
  const [live, setLive] = useState({});
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const r = await api.get("/quotes");
        if (alive) { setLive(r.data.quotes || {}); setReady(true); }
      } catch {
        if (alive) setReady(true);
      }
    };
    load();
    const id = setInterval(load, intervalMs);
    return () => { alive = false; clearInterval(id); };
  }, [intervalMs]);
  return { live, ready };
}

// Overlay real prices onto demo rows; flag which rows are live.
export function mergeLive(rows, live) {
  return rows.map((r) =>
    live[r.s] ? { ...r, p: live[r.s].p, d: live[r.s].dp, live: true } : { ...r, live: false }
  );
}

export function anyLive(rows) {
  return rows.some((r) => r.live);
}
